import React from 'react'
import {Form, Button, Row, Col} from "react-bootstrap";
import Api from "../../../helpers/Api";
import SubmitButton from "../components/SubmitButton";
import Heading from "../../../Components/Heading/Heading";

class PostForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            post: {},
            files: []
        }
    }

    componentDidMount() {
        let {match: {params}} = this.props;
        if (params.id) {
            this.loadData(params.id);
        }
    }

    loadData = (id) => {
        if (id === 'new') {
            return;
        }
        Api.call(`/translations/${id}`).then(post => {
            this.setState({post});
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        });
    };

    submit = (e) => {
        e.preventDefault();
        if (this.state.post.id) {
            this.update();
        } else {
            this.create();
        }
    };

    update = () => {
        this.setState({loading: true});
        Api.call(`/translations/${this.state.post.id}`, "POST", this.state.post).then(post => {
            this.setState({post: post});
            this.props.history.push('/app/translations');
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        })
    };
    create = () => {
        this.setState({loading: true});
        let {post, files} = this.state;

        Api.call(`/translations`, "POST", post).then(post => {
            this.setState({post: post});

            this.props.history.push('/app/translations');
        }).catch(console.log).finally(() => {
            this.setState({loading: false});
        })
    };
    onChange = (key, value) => {
        console.log(key, value);
        let {post} = this.state;
        post[key] = value;
        this.setState({post: post});
    };

    onFileChange = (key, value) => {
        console.log(key, value);
        let {files} = this.state;
        files[key] = value;
        var reader = new FileReader();

        this.setState({files: files});
        let url = reader.readAsDataURL(value);

        reader.onloadend = function (e) {
            this.setState({
                previewUrl: [reader.result]
            });
        }.bind(this);
    };


    render() {
        let {post} = this.state;
        return (
            <div className="dashboard">

                <Heading name="Edit"/>

                <div style={{marginTop: '70px'}}>
                    <Row>
                        <Col md={6}>
                            <Form autoComplete={'off'} onSubmit={this.submit}>
                                <Form.Group controlId="title">
                                    <Form.Label>key</Form.Label>
                                    <Form.Control type="text" value={post.key}
                                                  onChange={event => this.onChange('key', event.target.value)}
                                                  placeholder=""/>
                                </Form.Group>
                                <Form.Group controlId="excerpt">
                                    <Form.Label>Value</Form.Label>
                                    <Form.Control as="textarea" value={post.value}
                                                  onChange={event => this.onChange('value', event.target.value)}
                                                  rows="2"/>
                                </Form.Group>

                                <SubmitButton label={'Submit'} loading={this.state.loading}/>
                            </Form>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default PostForm
